module.exports = __webpack_public_path__ + "static/media/error.887ff221.svg";